const EmptyChart = () => {
  return (
    <div className="h-[290px] w-full flex flex-col justify-center items-center gap-4">
      <p className="text-xl text-[#303030] opacity-40">*cricket noises*</p>
    </div>
  );
};

export default EmptyChart;
